<template>
  <div class="card shadow-none">
    <div class="card-header">
        <h5 class="card-title"><i class="fas fa-utensils fa-fw"></i> Menu Guia Alimentaria</h5>
      </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th class="">Tiempo de comida</th>
              <th class="">Alimentos</th>
              <th >Preparación</th>
              <th class="">Cantidad</th>
              <th class=""></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(meal, mealIndex) in meals">
              <tr
                v-for="(item, itemIndex) in meal.items"
                :key="meal.id + '-' + itemIndex"
                :class="{ 'first-row': itemIndex === 0, 'extra-row': itemIndex > 0 }"
              >
                <td v-if="itemIndex === 0" :rowspan="meal.items.length + 1" >
                  <div :class="meal.colorClass">
                    <span>{{ meal.icon }}</span>
                    <span>{{ meal.label }}</span>
                  </div>
                </td>

                <td>
                    <textarea
                    v-model="item.alimento"
                    :class="{ 'is-invalid': $v.meals.$each.$iter[mealIndex]
                    .items.$each.$iter[itemIndex]
                        .alimento.$error }"
                        placeholder="Ej: arroz blanco, leche entera..."
                    class="form-control form-control-sm"
                  ></textarea>
                </td>
                <td class="">
                  <textarea
                    type="text"
                    v-model="item.preparacion"
                    :class="{
                      'is-invalid': $v.meals.$each.$iter[mealIndex]
                        .items.$each.$iter[itemIndex]
                        .preparacion.$error
                    }"
                    class="form-control form-control-sm"
                    placeholder="..."
                  ></textarea>
                </td>

                <td class="">
                  <textarea
                    type="text"
                    v-model="item.cantidad"
                    :class="{
                      'is-invalid': $v.meals.$each.$iter[mealIndex]
                        .items.$each.$iter[itemIndex]
                        .cantidad.$error
                    }"
                    class="form-control form-control-sm"
                    placeholder="Ej: 1 taza"
                  ></textarea>
                </td>

                <td class="">
                  <button
                    v-if="meal.items.length > 1"
                    class="btn btn-xs btn-outline-danger"
                    @click="removeItem(meal, itemIndex)"
                    title="Eliminar fila"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </td>
              </tr>

              <tr :key="`add-${meal.id}`" >
                <td>
                  <button class="btn btn-xs btn-outline-primary" @click="addItem(meal)">
                    <i class="fas fa-plus"></i> Agregar alimento
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import menuGuiaAlimentacionService from '@/services/menuGuiaAlimentacionService';
import Toast from '@/components/common/utilities/toast';
import { required } from "vuelidate/lib/validators";

export default {
  name: 'MenuGuiaAlimentacion',

  props: ['idHistoria', 'idUsuario','finalizada'],

  data() {
    return {
      meals: this.createMeals(),
    }
  },
  validations: {
    meals: {
      $each: {
        items: {
          $each: {
            alimento: {
              required
            },
            preparacion: {
              required
            },
            cantidad: {
              required
            }
          }
        }
      }
    }
  },
  methods: {
    createMeals() {
      const tiempos = [
        { id: 'desayuno',        label: 'Desayuno',        icon: '☀️', colorClass: 'badge badge-light' },
        { id: 'merienda_manana', label: 'Merienda mañana', icon: '🍎', colorClass: 'badge badge-light' },
        { id: 'almuerzo',        label: 'Almuerzo',        icon: '🍽️', colorClass: 'badge badge-light' },
        { id: 'merienda_tarde',  label: 'Merienda tarde',  icon: '🫖', colorClass: 'badge badge-light' },
        { id: 'cena',            label: 'Cena',            icon: '🌙', colorClass: 'badge badge-light' },
        { id: 'merienda_noche',  label: 'Merienda noche',  icon: '🌛', colorClass: 'badge badge-light' }
      ]
      return tiempos.map(function (t) {
        return Object.assign({}, t, {
          items: [{ alimento: '', preparacion: '', cantidad: '' }]
        })
      })
    },

    addItem(meal) {
      meal.items.push({ alimento: '', preparacion: '', cantidad: '' })
    },

    removeItem(meal, index) {
      meal.items.splice(index, 1)
    },

    buildPayload() {
      return {
        id_historia: this.idHistoria,
        id_usuario: this.idUsuario,
        tiempos: this.meals.map(function (m) {
          return {
            tiempo:    m.id,
            etiqueta:  m.label,
            alimentos: m.items.filter(function (i) { return i.alimento.trim() !== '' })
          }
        })
      }
    },

    async save() {
        try {
            this.$v.meals.$touch();
            if (this.$v.meals.$invalid) {
              Toast.fire({
                icon: 'error',
                title: 'Por favor, complete todos los campos requeridos',
                text: '',
                position: 'top-end',
              });
              return;
            }
            this.LoaderSpinnerShow();
            const response = await menuGuiaAlimentacionService.store(this.buildPayload());
            Toast.fire({
              icon: 'success',
              title: response.data.msg,
              position: 'top-end',
            });
            this.LoaderSpinnerHide();
        } catch (error) {
            console.log(error);
            Toast.fire({
              icon: 'error',
              title: 'Error al guardar los datos',
              position: 'top',
            });
            this.LoaderSpinnerHide();
        }
    },

    resetForm() {
      this.meals = this.createMeals()
      this.observaciones = ''
      this.errorMsg = ''
    },

    loadDataFromApi(apiTiempos) {
      if (!apiTiempos || !Array.isArray(apiTiempos) || apiTiempos.length === 0) return;
      const baseMeals = this.createMeals();
      this.meals = baseMeals.map(baseMeal => {
        const found = apiTiempos.find(t => t.tiempo === baseMeal.id);
        if (found) {
          baseMeal.hora = found.hora || '';
          if (found.alimentos && found.alimentos.length > 0) {
            baseMeal.items = found.alimentos.map(a => ({
               alimento: a.alimento || '',
               preparacion: a.preparacion || '',
               cantidad: a.cantidad || ''
            }));
          }
        }
        return baseMeal;
      });
    }
  },
  watch: {
    finalizada: async function (newVal) {
      if (newVal) {
        this.LoaderSpinnerShow();
        try {
          const response = await menuGuiaAlimentacionService.show(this.idHistoria);
          if (response.data && response.data.tiempos) {
            this.loadDataFromApi(response.data.tiempos);
          }
        } catch(e) {
          console.error(e)
        }
        this.LoaderSpinnerHide();
      }
    }
  },
  async created() {
    if (this.finalizada=='N') {
      this.LoaderSpinnerShow();
      try {
        const response = await menuGuiaAlimentacionService.show(this.idHistoria);
        if (response.data && response.data.tiempos) {
          this.loadDataFromApi(response.data.tiempos);
        }
      } catch(e) {
        console.error(e)
      }
      this.LoaderSpinnerHide();
    }
  }
}
</script>


